export const toggleMandatory = (list, index) =>
  list.map((item, idx) => (idx === index ? { ...item, isMandatory: item.isMandatory === 1 ? 0 : 1 } : item));
